module.exports = __webpack_public_path__ + "media/images/lb/279-24ab900a60b502061332f9fbda703dfa.svg";